import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5f67092c&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f67092c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f67092c')) {
      api.createRecord('5f67092c', component.options)
    } else {
      api.reload('5f67092c', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=5f67092c&scoped=true&", function () {
      api.rerender('5f67092c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/reporting-channel/reports/type-reporting/Index.vue"
export default component.exports